import { useEffect } from "react";
import { PublicNav } from "../components/site/PublicNav";
import { PublicFooter } from "../components/site/PublicFooter";

const SECTIONS = [
  {
    title: "1. Acceptance of terms",
    body: "By accessing synqsmc.com or using the SynqSMC ERP at erp.synqsmc.com (together, the \"Service\"), you agree to these Terms & Conditions. If you use the Service on behalf of a housing society or company, you confirm you are authorised to accept these terms on its behalf.",
  },
  {
    title: "2. The Service",
    body: "SynqSMC provides software for society management, including tenant management, maintenance billing and collections, notice boards, complaints, amenity bookings and reports. Features available to you depend on your subscription plan. We may improve or modify features over time.",
  },
  {
    title: "3. Accounts and responsibilities",
    body: "Account credentials are created and assigned by platform or society administrators. You are responsible for keeping your password confidential and for all activity under your account. Society administrators are responsible for the accuracy of the data they enter (billing amounts, notices, member details) and for having the authority to store resident data on the platform.",
  },
  {
    title: "4. Acceptable use",
    body: "You must not misuse the Service: no unauthorised access attempts, no uploading of unlawful or defamatory content, no scraping, and no interference with the platform's operation. We may suspend accounts that violate these rules.",
  },
  {
    title: "5. Subscriptions and payment",
    body: "Paid plans are billed per society per month as shown on our Pricing page or your order form. Fees are non-refundable except where required by law. We may change pricing with 30 days' notice. Non-payment may lead to suspension of the affected society's workspace.",
  },
  {
    title: "6. Your data",
    body: "You and your society retain ownership of all data entered into the Service. You grant us only the rights needed to operate the Service. You can export or request deletion of your society's data at any time by contacting support@synqsmc.com.",
  },
  {
    title: "7. Service availability",
    body: "We target 99.9% uptime but do not guarantee uninterrupted service. Planned maintenance will be communicated in advance where possible. The Service is a management tool; financial records produced by it should be verified by your society's accountant before statutory use.",
  },
  {
    title: "8. Limitation of liability",
    body: "To the maximum extent permitted by law, SynqSMC is not liable for indirect or consequential damages, loss of data, or loss of profits arising from use of the Service. Our aggregate liability is limited to the fees paid by your society in the 12 months preceding the claim.",
  },
  {
    title: "9. Termination",
    body: "You may cancel at any time. We may terminate or suspend access for breach of these terms. On termination, your data remains available for export for 30 days, after which it may be deleted.",
  },
  {
    title: "10. Governing law",
    body: "These terms are governed by the laws of India, with courts at Mumbai, Maharashtra having exclusive jurisdiction.",
  },
  {
    title: "11. Contact",
    body: "Questions about these terms: support@synqsmc.com.",
  },
];

export default function Terms() {
  useEffect(() => {
    document.title = "Terms & Conditions — SynqSMC";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid="terms-page" className="bg-white">
      <PublicNav />
      <main className="mx-auto max-w-3xl px-5 pb-24 pt-36 sm:px-8">
        <p className="eyebrow mb-4">Legal</p>
        <h1 className="text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl" data-testid="terms-heading">
          Terms &amp; Conditions
        </h1>
        <p className="mt-3 text-sm text-slate-400">Effective date: 14 October 2026</p>
        <div className="mt-10 space-y-8">
          {SECTIONS.map((s) => (
            <section key={s.title}>
              <h2 className="text-lg font-bold text-slate-900">{s.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
      <PublicFooter />
    </div>
  );
}
